import { render, staticRenderFns } from "./DiarySampleResource.vue?vue&type=template&id=7816ea13&scoped=true&"
import script from "./DiarySampleResource.vue?vue&type=script&lang=js&"
export * from "./DiarySampleResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7816ea13",
  null
  
)

export default component.exports